import { DisplayPosition } from '@/common/manager/position/display-position';
export const config = {
    position: [DisplayPosition.cnArrayTable],
    componentName: 'CnArrayTableIndex',
    tableColumnBeforeHandler: ({ tableColumn, formItem }) => {
        const width = formItem?.['x-component-props']?.width;
        if (width && tableColumn?.['x-component-props']) {
            tableColumn['x-component-props'].width = width;
        }
        const fixed = formItem?.['x-component-props']?.fixed;
        if (fixed && tableColumn?.['x-component-props']) {
            tableColumn['x-component-props'].fixed = 'left';
        }
    },
};
